export default __webpack_public_path__ + "img/6073e185eb72b19740bfbcbd29d2dae9.svg";